<template>
  <div class="py-1">
    <MenuOption
      id="resend-reports"
      :title="$t('W: Send rapporter igen')"
      @select="onResendClick">
      <template #icon>
        <IconLucideSend class="h-4 w-4" />
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'OrderResendReportsMenu',

  emits: ['close'],

  props: {
    onResend: { type: Function as PropType<() => void>, required: true },
  },

  methods: {
    onResendClick(): void {
      this.onResend()
      this.$emit('close')
    },
  },
}
</script>
